import React, {useState} from 'react'
import './ChatScreen.css'
import Avatar from '@material-ui/core/Avatar';

export default function ChatScreen() {
    const [input, setInput] = useState()
    const [messages,setMessages] = useState([
        {
            name:"Ellen", 
            image:'https://images.pexels.com/photos/4197491/pexels-photo-4197491.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940',
            message:"How are you"
        },
        {
            name:"Ellen", 
            image:'https://images.pexels.com/photos/4197491/pexels-photo-4197491.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940',
            message:"How have been"
        },
        {
            message:"I have been good"
        }
    ])

    const handleSend = e => {
        e.preventDefault()
        setMessages([...messages, {message: input}])
        setInput('');
    } 
    return (
        <div className="chatScreen">
        <h2 className="chatScreen__header"> Yo have matched with Marko</h2>
        {
            messages.map(message =>(
                message.name ? (
                    <div className="chatScreen__message">
                    <Avatar
                        className="chatScreen__image"  
                        alt={message.name}
                        src={message.image}                  
                     />
                     <p className="chatScreen__text">{message.message}</p>
                     
                </div>     

                ):(
                    <div className="chatScreen__message">
                        <p className="chatScreen__textUser">{message.message}</p>
                    </div>

                )
                          
            ))
        }          
        
            <form className="chatScreen__input">
                <input
                value={input}
                onChange={e => setInput(e.target.value)}
                className="chatScreen__inputField" 
                placeholder="Type a message here"
                type="text"
                />
                <button onClick={handleSend} type="submit" className="chatScreen__inputButton">Send</button>
            </form>
        
        </div>
       
    )
}
